const initialState = {
  isOn2: false
}


export const navigationReducer2 = (state = initialState, action) => {
  switch (action.type) {

    case "SET_NAVIGATION2": {
      return { ...state, isOn2: action.data }
    }

    default:
      return state;

  }
};